// Jedini izvor izgleda antd komponenti (dugmad, inputi, selecti, dropdown-i,
// date pickeri...). Umesto globalnih CSS override-a sa !important, boje i
// dimenzije se zadaju kroz design tokene. Vrednosti prate src/styles/variables.scss.

const colors = {
  primary: '#6e8eb1',

  title: '#1a1a1a',
  text: '#5b6470',
  muted: '#9aa7b8',
  border: '#e6e6e6',
  bg: '#f5f4f4',
  danger: '#d1495b',
};

const antdTheme = {
  token: {
    colorPrimary: colors.primary,
    colorInfo: colors.primary,
    colorLink: colors.primary,
    colorError: colors.danger,
    // Svi "success" elementi (check ikonice, success Alert, toast) su u
    // primarnoj plavoj, ne zelenoj.
    colorSuccess: colors.primary,
    colorText: colors.title,
    colorTextSecondary: colors.text,
    colorTextPlaceholder: colors.muted,
    colorBorder: colors.border,
    colorBorderSecondary: colors.border,
    colorBgLayout: colors.bg,

    fontFamily: "'Poppins', sans-serif",
    fontSize: 13,

    // Kompaktne kontrole: 32px (default), 26px (small), 38px (large).
    controlHeight: 32,
    controlHeightSM: 26,
    controlHeightLG: 38,
    borderRadius: 8,
    borderRadiusSM: 6,
    borderRadiusLG: 12,

    boxShadowSecondary: '0 6px 16px 0 rgba(16, 24, 40, 0.08)',
  },
  components: {
    Button: {
      fontWeight: 500,
      primaryShadow: '0 1px 4px 0 rgba(110, 142, 177, 0.25)',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Select: {
      optionSelectedBg: colors.bg,
      optionActiveBg: colors.bg,
      optionSelectedFontWeight: 500,
    },
    Dropdown: {
      controlItemBgHover: colors.bg,
    },
    Tabs: {
      itemColor: colors.text,
      itemSelectedColor: colors.primary,
      inkBarColor: colors.title,
    },
    Modal: {
      titleFontSize: 20,
      titleLineHeight: 1.4,
    },
    // Obavestenja (useToast) - kompaktna, kao ostale kontrole dashboarda.
    Notification: {
      width: 320,
      fontSizeLG: 14,
      paddingMD: 12,
      paddingContentHorizontalLG: 16,
      progressBg: colors.primary,
    },
    // Zakljucan Input/TextArea (van edit moda) - tekst citljiv (adresa se
    // prepisuje rucno), umesto bledog "disabled" sivog.
    Input: {
      colorTextDisabled: colors.title,
    },
    Form: {
      labelFontSize: 13,
      verticalLabelPadding: '0 0 6px',
    },
  },
};

export default antdTheme;
